module.exports = __webpack_public_path__ + "img/moti_2.c98b74a0.png";